<template>
  <v-container style="position:relative;overflow-y:auto;display:flex;flex-direction:row;height:inherit;">
    <div style="position:absolute;z-index:5;left:26px;top:26px;width:180px!important" class="">
      <v-btn depressed class="custom-header-btn font-italic font-weight-medium" @click="dialogConfirmCancel = true"> <v-icon> mdi-close </v-icon> {{  $t('global.leave')  }}</v-btn>
    </div>
    <v-dialog v-model="dialogConfirmCancel" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
      <v-card class="pa-4">
        <v-card-text class="mt-3 title font-italic" style="color:var(--v-primary-base);">
          {{ $t('userMessage.creation-leave-title') }}
        </v-card-text>
        <v-tooltip open-delay="800ms" bottom color="rgba(var(--new-media-rgb),1)">
          <template v-slot:activator="{ on }">
            <img class="mb-2" style="height:274px;width:274px;" src="@/assets/images/illu_delete_newMedia.png"  v-on="on">
          </template>
          <span>Illustration : Ivan Haidutski</span>
        </v-tooltip>
        <v-card-text class="body-2" style="color:var(--v-primary-base);">
          {{ $t('userMessage.creation-leave-message') }}
        </v-card-text>
        <v-card-text class="font-weight-medium" style="color:var(--v-primary-base);"><v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
          {{ $t('userMessage.media-delete-warning') }}
        </v-card-text>
        <v-card-actions>
          <v-btn large rounded depressed text style="width:45%" @click="dialogConfirmCancel = false">{{ $t('global.cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn large outlined rounded style="width:45%" class="custom-valid-btn new-media" @click="closeModal">{{ $t('global.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-stepper style="margin-left:180px;height:100%!important;width:inherit;overflow-y:auto;" class="d-inline-block" v-model="stepModel" vertical>
      <v-stepper-step @click="goToPreviousStep(1)" step="1" :complete="stepModel > 1"> 
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep1.darkSrc : iconStep1.lightSrc"></v-img>
          <div class="headline font-weight-light">
            {{  $t('creation.steps.1b') }}
            <v-tooltip color="new_media" right>
              <template v-slot:activator="{on}">
                <v-icon id="goBack" class="ml-1" color="primary" style="opacity:0;visibility:hidden" v-on="on">mdi-undo-variant</v-icon>
              </template>
              <span>{{ $t('global.backStep') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="1">
        <div v-if="validFormat">
          <video v-if="hasLandscapeScreens" ref="landscapeVideo" id="landscapeVideo" height="270" width="480" :src="videoSrc" muted controls></video>
          <video v-if="hasPortraitScreens" ref="portraitVideo" id="portraitVideo" height="270" width="152" :src="videoSrc" muted controls></video>
          <video v-if="hasLedScreens" ref="ledVideo" id="ledVideo" height="270" width="360" :src="videoSrc" muted controls></video>
        </div>
        <div v-if="!validFormat">
          Prévisualisation temporairement indisponible pour ce format de vidéo.
        </div>
        <div v-if='showSound' style="margin-left:20px;display:flex!important;flex-direction:row!important;justify-content:start!important;max-width:1124px;">
          <div class="divObject custom-center pl-3">
            <v-switch inset hide-details color="new_media" class="form-checkbox" label="Son" v-model="sound"></v-switch>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;justify-content:start;margin-top:20px;margin-left:16px">
          <v-btn rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" @click="toStepTwo"> {{  $t('creation.steps.2') }} <v-icon large class="ml-2">mdi-arrow-down-circle</v-icon> </v-btn>
        </div>
      </v-stepper-content>
      <v-stepper-step @click="goToPreviousStep(2)" :complete="stepModel > 2" step="2">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep2.darkSrc : iconStep2.lightSrc"></v-img>
          <div class="headline font-weight-light"> {{  $t('creation.steps.2') }}
            <v-tooltip color="new_media" right>
              <template v-slot:activator="{on}">
                <v-icon id="goBack" class="ml-1" color="primary" style="opacity:0;visibility:hidden" v-on="on">mdi-undo-variant</v-icon>
              </template>
              <span>{{ $t('global.backStep') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="2">
          <div>
            <div class="d-inline-block vert-align-top mr-10">
              <h3 class="mb-2">
                Programmation
              </h3>
              <div class="mb-4 d-flex flex-column">
                <span class="caption text-center">Début de diffusion</span>
                <v-menu
                  ref="startingDate"
                  v-model="menuStartingDate"
                  :close-on-content-click="false"
                  :return-value.sync="startingDate"
                  transition="scale-transition"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startingDate"
                      :readonly="true"
                      :hide-details="true"
                      :single-line="true"
                      v-on="on"
                      class="custom-text-field"
                      color="new_media"
                      style="width:180px!important;"
                      prepend-inner-icon="mdi-calendar-check"
                      outlined
                      rounded
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="startingDate" scrollable :locale="$store.state.user.language">
                    <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuStartingDate = false">Annuler</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.startingDate.save(startingDate)">Valider</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="d-flex flex-column">
                <span class="caption text-center">Fin de diffusion</span>
                <v-menu
                  ref="endingDate"
                  v-model="menuEndingDate"
                  :close-on-content-click="false"
                  :return-value.sync="endingDate"
                  transition="scale-transition"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endingDate" 
                      placeholder="_ _ _ _-_ _-_ _"
                      :readonly="true"
                      :hide-details="true"
                      :single-line="true"
                      v-on="on"
                      class="custom-text-field"
                      color="new_media"
                      style="width:180px!important;"
                      prepend-inner-icon="mdi-calendar-remove"
                      outlined
                      rounded
                      dense
                      clearable
                      clear-icon="mdi-close-circle"
                    ></v-text-field>
                  </template>
                  <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="endingDate" scrollable :locale="$store.state.user.language">
                    <v-spacer></v-spacer>
                    <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuEndingDate = false">Annuler</v-btn>
                    <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.endingDate.save(endingDate)">Valider</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="d-inline-block broadcast-days-div mr-10">
              <h3 class="mb-2">
                {{ $t('newMedia.broadcastDays') }}
              </h3>
              <div id="broadcastDays_container" style="display:flex; flex-direction:column; height:100%; max-width:380px;">
                  <v-row no-gutters>
                    <template v-for="day in broadcastDays">
                      <v-col :key="day.id" >
                        <div class="divObject custom-center pl-3" style="background-color:transparent;width:180px!important;margin-right:0!important;">
                          <v-switch inset dense hide-details class="form-checkbox" color="new_media" :label="day.name" v-model="chosenDays" :value="day">
                          </v-switch>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
              </div>
            </div>
            <div class="d-inline-block vert-align-top" style="width:280px!important;overflow:visible;">
              <h3 class="mb-2">
                Horaires de diffusion
              </h3>
              <div v-if="setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
                <p class="px-4 text-center">Plage horaire activée<v-icon class="ml-2" color="new_media">mdi-check-circle</v-icon></p>
                <div class="d-flex flex-row justify-space-between px-4 mb-4">
                  <div class="d-flex flex-column">
                    <span class="caption mb-1">Commence à </span>
                    <vue-time-picker :minute-interval="10" class="custom-time-picker" color="new_media" v-model="startingHour">
                    </vue-time-picker>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="caption mb-1">Se termine à </span>
                    <vue-time-picker :minute-interval="10" class="custom-time-picker" color="new_media" v-model="endingHour">
                    </vue-time-picker>
                  </div>
                </div>
                <v-btn
                  depressed
                  block
                  dark
                  color="var(--v-error-darken1)"
                  style="border-radius:0 0 18px 18px;text-transform:none;"
                  @click="removeHours">
                  <v-icon class="mr-2">
                    mdi-chevron-right
                  </v-icon>
                  Diffuser toute la journée
                  <v-icon class="ml-2">
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
              </div>
              <div v-if="!setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
                <p class="px-4 text-center">
                  Diffusion toute la journée
                  <v-icon class="ml-2" color="new_media">
                    mdi-check-circle
                  </v-icon>
                </p>
                <v-btn
                  depressed
                  block
                  dark
                  color="new_media"
                  class="font-weight-medium"
                  style="border-radius:0 0 18px 18px;text-transform:none;"
                  @click="setBroadCastHours = true">
                <v-icon class="mr-2">
                  mdi-chevron-right
                </v-icon>
                  Activer une plage horaire
                <v-icon class="ml-2">
                  mdi-chevron-left
                </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div style="height:auto;max-height:500px;;overflow-x:hidden;overflow-y:auto;">
            <div class="d-flex flex-row justify-start" v-if="$store.state.user.id !== 295">
              <h3 class="mr-6">
                Selection des écrans de diffusion ({{ chosenScreens.length }})
              </h3>
              <v-select v-if="$store.state.user.sites.length > 1" :items="availableSites"
                item-text="SitNom"
                item-value="SitId"
                v-model="currentSite"
                append-icon="mdi-chevron-down"
                style="max-width:270px!important;"
                class="pr-3 mr-2 custom"
                return-object
                :hide-details="true"
                rounded
                filled
                dense
                menu-props="auto"
              >
              </v-select>
              <v-switch v-if="$store.state.user.sites.length > 1" inset dense hide-details class="form-checkbox" color="new_media" label="Tous les écrans du site" v-model="allScreensFromCurrentSite" @change="setAllScreensFromCurrentSite">
              </v-switch>
              <v-switch v-if=" $store.state.user.id === 295 || $store.state.user.sites.length === 1" inset dense hide-details class="form-checkbox" color="new_media" label="Tous les écrans" v-model="allScreens" @change="setAllScreens">
              </v-switch>
            </div>
             <div class="d-flex flex-row justify-start" v-if="$store.state.user.id === 295 && $store.state.selectedSite.SitNom === 'Tous'">
              <h3 class="mr-6">
                Selection des groupes de diffusion ({{ selectedCultura.length }})
              </h3>
              <v-switch inset dense hide-details class="form-checkbox" color="new_media" label="Tous les groupes" v-model="allGroups">
              </v-switch>
            </div>
            <div class="d-flex flex-row justify-start">
              <v-switch class="ml-6" v-for="enseigne in tempKazed" @change="addBrandScreens(enseigne)" :key='enseigne.name' :value="enseigne" inset dense hide-details  color="new_media" :label="enseigne.name" v-model="selectedKazed">
              </v-switch>
            </div>
             <v-row no-gutters v-if="$store.state.user.id !== 295">
              <template v-for="screen in availableScreens">
                <v-col :key="screen.id" class="align-start col-lg-2 col-md-3 col-sm-6">
                  <div v-if="!chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-0 select-screen-image-bloc" @click="addScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-new_media-base)!important" class="select-screen-button">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g, ' ') }} </span>
                    </div>
                  </div>
                  <div v-if="chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-12 new_media select-screen-image-bloc" style="background-color:var(--v-new_media-base);" @click="removeScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-primary-base)!important" class="select-screen-button">
                          <v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g,' ') }} </span>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
            <v-row no-gutters v-if="$store.state.user.id === 295 && $store.state.selectedSite.SitNom === 'Tous'">
              <template v-for="group in tempCultura">
                <v-col :key="group.name" class="align-start col-lg-2 col-md-3 col-sm-6">
                  <div v-if="!selectedCultura.includes(group)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-0 select-screen-image-bloc" @click="addGroup(group)">
                      <v-img class="select-screen-image" contain :src="screenIcon(group.type)" >
                        <v-btn small fab dark color="var(--v-new_media-base)!important" class="select-screen-button">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ group.name }} </span>
                    </div>
                  </div>
                  <div v-if="selectedCultura.includes(group)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-12 new_media select-screen-image-bloc" style="background-color:var(--v-new_media-base);" @click="removeGroup(group)">
                      <v-img class="select-screen-image" contain :src="screenIcon(group.type)" >
                        <v-btn small fab dark color="var(--v-primary-base)!important" class="select-screen-button">
                          <v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ group.name }} </span>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
            <!-- <div>
              <v-checkbox color="new_media" class="d-inline-block" v-for="screen in availableScreens" :key="screen.id" :label="screen.server_name" v-model="chosenScreens" :value="screen"></v-checkbox>
            </div> -->
          </div>
          <div>
            <v-btn rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" :disabled="(chosenScreens.length<1  && selectedCultura.length<1) || chosenDays.length<1 || ((!isStartingHourValid || !isEndingHourValid) && setBroadCastHours)" @click="toStepThree">{{  $t('creation.steps.3') }} <v-icon large class="ml-2">mdi-arrow-down-circle</v-icon> </v-btn>
          </div>
        </v-stepper-content>
      <v-stepper-step step="3">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep3.darkSrc : iconStep3.lightSrc"></v-img>
          <div class="headline font-weight-light"> {{  $t('creation.steps.3') }}</div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="3">
        <div class="d-inline-flex flex-column">
          <div class="d-inline-flex flex-row elevation-8-05" style="border-radius:10px!important;overflow:hidden;">
            <div class="pa-3 d-inline-flex flex-column justify-center align-end" style="color:white;background-color:var(--v-new_media-base);width:230px;">
              <span>
                <v-icon dark>mdi-calendar-month</v-icon>
                Programmation
              </span>
              <span v-html="schedule" class="font-italic font-weight-regular" style="text-align:right;margin-bottom:10px;"> 
              </span>

              <span>
                <v-icon dark>mdi-calendar-check</v-icon>
                Jours de diffusion
              </span>
              <div class="d-flex flex-row flex-wrap justify-end" style="margin-bottom:10px;">
                <span class="font-italic font-weight-regular text-right" v-html="orderedDays">
                </span>
              </div>

              <div v-if="setBroadCastHours">
                <span >
                  <v-icon dark>mdi-clock-outline</v-icon>
                  Horaires de diffusion
                </span>
                <div class="d-flex flex-row flex-wrap justify-end">
                  <span class="font-italic font-weight-regular">
                    {{ hours }}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <video id="landscapeVideo" height="270" width="480" :src="videoSrc" muted></video>
            </div>
          </div>
          <div class="d-inline-flex">
            <v-icon x-large color="new_media">mdi-subdirectory-arrow-right</v-icon>
            <v-text-field
                label="Nommez votre média pour mieux le retrouver !"
                v-model="videoName"
                color="new_media"
                class="mt-4 pt-3 ml-1"
                outlined
                rounded
                dense
              ></v-text-field>
            </div>
        </div>
        <div style="margin-top:20px;">
          <v-btn :loading="loading" rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" @click="uploadVideo" :disabled="videoName === null || videoName === ''">
            Envoyer en diffusion
            <v-icon large class="mx-2">
              mdi-television-play
            </v-icon>
          </v-btn>
          <span class="ml-2">
            {{ uploadMessage }} {{ uploadProgress }}
          </span>
        </div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import FtpService from '@/services/FTPService'
import DBService from '@/services/DBService'
export default {
  data () {
    return {
      stepModel: 1,
      file: null,
      videoSrc: '',
      validFormat: true,
      startingDate: new Date().toISOString().substr(0, 10),
      endingDate: null,
      menuStartingDate: false,
      menuEndingDate: false,
      modal: false,
      menu2: false,
      broadcastDays: [
        { id: 0, code: '', name: this.$i18n.t('global.days.0') },
        { id: 4, code: 'J', name: this.$i18n.t('global.days.4') },
        { id: 1, code: 'L', name: this.$i18n.t('global.days.1') },
        { id: 5, code: 'V', name: this.$i18n.t('global.days.5') },
        { id: 2, code: 'A', name: this.$i18n.t('global.days.2') },
        { id: 6, code: 'S', name: this.$i18n.t('global.days.6') },
        { id: 3, code: 'R', name: this.$i18n.t('global.days.3') },
        { id: 7, code: 'D', name: this.$i18n.t('global.days.7') }
      ],
      chosenDays: [{ id: 0, code: '', name: this.$i18n.t('global.days.0') }],
      nameExtension: '',
      availableScreens: null,
      screensbySite: [],
      chosenScreens: [],
      startingHour: {
        HH: '',
        mm: '00'
      },
      endingHour: {
        HH: '',
        mm: '00'
      },
      selectedIcons: [],
      isStartingHourValid: true,
      isEndingHourValid: true,
      snackbarUploadSuccessful: false,
      snackbarUploadFailed: false,
      resizedImage: null,
      timeoutDuration: 4000,
      doneFetchingImage: false,
      canvasHeight: 270,
      landscapeWidth: 480,
      portraitWidth: 152,
      currentTheme: null,
      ledWidth: 360,
      videoName: '',
      banner: false,
      videoFormat: '',
      setBroadCastHours: false,
      iconStep1: {lightSrc: require('../../assets/images/light_ic_creation_step1.png'), darkSrc: require('../../assets/images/dark_ic_creation_step1.png')},
      iconStep2: {lightSrc: require('../../assets/images/light_ic_creation_step2.png'), darkSrc: require('../../assets/images/dark_ic_creation_step2.png')},
      iconStep3: {lightSrc: require('../../assets/images/light_ic_creation_step3.png'), darkSrc: require('../../assets/images/dark_ic_creation_step3.png')},
      imgSrcLandscape: require('@/assets/images/light_ic_screen_landscape.png'),
      imgSrcPortrait: require('@/assets/images/light_ic_screen_portrait.png'),
      imgSrcLED: require('@/assets/images/light_ic_screen_led.png'),
      selectedLandscapeScreens: [],
      selectedPortraitScreens: [],
      selectedLedScreens: [],
      selectedLandscapeGroups: [],
      selectedPortraitGroups: [],
      selectedLedGroups: [],
      hasLandscapeScreens: false,
      hasPortraitScreens: false,
      hasTwoByFourScreens: false,
      hasLedScreens: false,
      loading: false,
      selectedDaysIDCSV: '',
      videoDuration: 0,
      dialogConfirmCancel: false,
      uploadMessage: '',
      uploadProgress: '',
      showSound: false,
      sound: false,
      allScreens: false,
      allGroups: false,
      tempKazed: [  
      ],
      selectedKazed: [],
      tempCultura: [  
      ],
      selectedCultura: [],
      availableSites: this.$store.state.user.sites,
      currentSite: this.$store.state.selectedSite,
      allScreensFromCurrentSite: false
    }
  },
  components: {
    'vueTimePicker': VueTimepicker
  },
  created () {
    this.currentTheme = this.$store.state.theme
  },
  async mounted () {
    var options = this.$store.state.user.options
    options.forEach(option => {
      if (option.id === 2 ){
        this.showSound = true
      }
    })
    this.availableScreens = this.$store.state.selectedSite.screens
    if (this.$store.state.selectedSite.SitNom.includes('Kazed')) {
      this.tempKazed = [{name: 'Castorama', prefix: 'Casto_'},
        {name: 'Mr Bricolage', prefix: 'MrBricolage_'},
        {name: 'Entrepôt du bricolage', prefix: 'EDB_'},
        {name: 'BBJ', prefix: 'BBJ_'},
        {name: 'Autre', prefix: ''}]
    } else if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom.includes('Tous')) {
      var screens = []
      var duplicateCheck = []
      this.$store.state.user.sites.forEach(site => {
        site.screens.forEach(screen => {
          if (!duplicateCheck.includes(screen.name)) {
            duplicateCheck.push(screen.name)
            var screentype = 1
            if (screen.name.toLowerCase().includes('portrait')) {
              screentype = 2
            } else if (screen.name.toLowerCase().includes('led')) {
              screentype = 3
            }
            this.tempCultura.push({
              name: screen.name,
              type: screentype
            })
          }
          screens.push(screen)
        })
      })
      this.availableScreens = screens
    } else {
      this.availableScreens = this.$store.state.selectedSite.screens.filter(screen => screen.name !== "Ligne de caisse")
      for (let i = 0; i < this.availableSites.length; i++) {
      this.screensbySite.push({
        site: this.availableSites[i],
        screens: []
      })
      this.availableSites[i].screens.forEach(screen => {
        if (screen.name !== "Ligne de caisse") {
          if (screen.fk_screen_type === 4) {
            this.hasPortraitScreens = true
            this.hasTwoByFourScreens = true
          }
          if (screen.fk_screen_type === 1) {
            this.hasLandscapeScreens = true
          } else if (screen.fk_screen_type === 2) {
            this.hasPortraitScreens = true
          } else if (screen.fk_screen_type === 3) {
            this.hasLedScreens = true
          }
        }
      })
    }
    }
    var site = {}
    if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom.includes('Tous')) {
      site.SitNom = 'Cultura'
    } else {
      site = this.$store.state.selectedSite
    }
    this.file = this.$store.state.file
    // Si IE / Safari il faut afficher que .mp4
    if (this.file) {
      this.videoFormat = this.file.name.split('.')[this.file.name.split('.').length - 1]
      if (this.file.name.endsWith('.mp4') || this.file.name.endsWith('.webm') || this.file.name.endsWith('.ogg')) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.videoSrc = e.target.result
        }
        reader.readAsDataURL(this.file)
      } else {
        this.validFormat = false
      }
    } else {
      this.videoSrc = this.$store.state.pixabayVideoURL  
    }
   
  },
  methods: {
    goToPreviousStep (clickedStep) {
      if (this.stepModel > clickedStep) {
        this.stepModel = clickedStep
      }
    },
    closeModal () {
      this.$store.dispatch('setPixabayVideoURL', null)
      this.$store.dispatch('setMediaToEdit', null)
      this.$store.dispatch('setFile', null)
      this.$store.dispatch('setPixabayImageID', 0)
      this.$store.dispatch('setUploadSuccessful', false)
      this.$store.dispatch('setPixabayImageURL', null)
      this.$emit('close')
    },
    toStepTwo () {
      this.stepModel = 2
      if (this.videoSrc !== '' && this.validFormat) {
        if (this.hasLandscapeScreens || this.selectedLandscapeGroups.length > 0) {
          if (document.getElementById('landscapeVideo').duration === NaN) {
            document.getElementById('landscapeVideo').play()
          }
          this.videoDuration = document.getElementById('landscapeVideo').duration
          document.getElementById('landscapeVideo').pause()
        }
        if (this.hasPortraitScreens || this.selectedPortraitGroups.length > 0) {
          if (this.videoDuration === NaN || this.videoDuration === 0) {
            if (document.getElementById('portraitVideo').duration === NaN) {
              document.getElementById('portraitVideo').play()
            }
            this.videoDuration = document.getElementById('portraitVideo').duration
          }
          document.getElementById('portraitVideo').pause()
        }
        if (this.hasLedScreens || this.selectedLedGroups.length > 0) {
           if (this.videoDuration === NaN || this.videoDuration === 0) {
            if (document.getElementById('portraitVideo').duration === NaN) {
              document.getElementById('portraitVideo').play()
            }
            this.videoDuration = document.getElementById('portraitVideo').duration
          }
          document.getElementById('ledVideo').pause()
        }
      }      
    },
    setAllScreens: function () {
      this.chosenScreens = this.allScreens ? this.availableScreens : []
      var currSite = this.currentSite
      var allScreens = this.chosenScreens
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens = this.chosenScreens
        }
      })
    },
    setAllScreensFromCurrentSite () {
      var currSite = this.currentSite
      this.chosenScreens = this.chosenScreens.filter(function (element) {
        if (element.fk_site_id !== currSite.SitId)
          return element
      })
      var isChecked =  this.allScreensFromCurrentSite
      var allScreens = this.availableScreens
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens = []
          if (isChecked) {
            element.screens = allScreens
          }
        }
      })
      if (this.allScreensFromCurrentSite) {
        this.chosenScreens = this.chosenScreens.concat(this.availableScreens)
      }
    },
    toStepThree () {
      this.selectedLandscapeScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 1
      })
      this.selectedPortraitScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 2 || element.fk_screen_type === 4
      })
      this.selectedLedScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 3
      })
      this.stepModel = 3
      if (this.validFormat){
        if (this.videoDuration === NaN || this.videoDuration === 0) {       
          if (this.hasLandscapeScreens || this.selectedLandscapeGroups.length > 0) {
            if (document.getElementById('landscapeVideo').duration === NaN) {
              document.getElementById('landscapeVideo').play()
            }
            this.videoDuration = document.getElementById('landscapeVideo').duration
            document.getElementById('landscapeVideo').pause()
          }
          if (this.hasPortraitScreens || this.selectedPortraitGroups.length > 0) {
            if (this.videoDuration === NaN || this.videoDuration === 0) {
              if (document.getElementById('portraitVideo').duration === NaN) {
                document.getElementById('portraitVideo').play()
              }
              this.videoDuration = document.getElementById('portraitVideo').duration
            }
            document.getElementById('portraitVideo').pause()
          }
          if (this.hasLedScreens || this.selectedLedGroups.length > 0) {
              if (this.videoDuration === NaN || this.videoDuration === 0) {
              if (document.getElementById('ledVideo').duration === NaN) {
                document.getElementById('ledVideo').play()
              }
              this.videoDuration = document.getElementById('ledVideo').duration
            }
            document.getElementById('ledVideo').pause()
          }
        }
      }
      this.nameExtension = '__jd'

      this.selectedDaysIDCSV = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          this.selectedDaysIDCSV = '0,'
          this.nameExtension = ''
          break
        } else {
          this.nameExtension += this.chosenDays[i].code
          this.selectedDaysIDCSV += this.chosenDays[i].id + ','
        }
      }
      this.selectedDaysIDCSV = this.selectedDaysIDCSV.substring(0, this.selectedDaysIDCSV.length - 1)
      if (this.setBroadCastHours) {
        if (this.startingHour) {
          let minutes = this.startingHour.mm === '' ? '00' : this.startingHour.mm
          let hours = this.startingHour.HH
          this.nameExtension += '__hd' + hours + minutes
          this.startingHourFormat = hours + minutes
        }
        if (this.endingHour) {
          let minutes = this.endingHour.mm === '' ? '00' : this.endingHour.mm
          let hours = this.endingHour.HH
          this.nameExtension += '__hf' + hours + minutes
          this.endingHourFormat = hours + minutes
        }
      }
      if (this.startingDate) {
        let dateElements = this.startingDate.split('-')
        this.nameExtension += '__d' + dateElements[0] + dateElements[1] + dateElements[2]
      }
      if (this.endingDate) {
        let dateElements = this.endingDate.split('-')
        this.nameExtension += '__f' + dateElements[0] + dateElements[1] + dateElements[2]
      }
    },
    async uploadVideo () {
      setTimeout( () => {
        this.uploadMessage = 'Envoi de votre vidéo sur le serveur.'
      }, 1000)
      this.videoDuration = Math.trunc(this.videoDuration)
      var random = Math.floor(Math.random() * Math.floor(4)) + 1
      var uniqueID = Date.now()
      this.loading = true
      if (this.file) {
        var reader = new FileReader()
        reader.onload = async (e) => {
          var propertiesDataObject = {
            titre: this.videoName,
            bandeauEnseigne: false,
            etat: 1,
            selectedDays: this.selectedDaysIDCSV,
            dateDebut: this.startingDate,
            dateFin: this.endingDate,
            heureDebut: this.startingHourFormat,
            heureFin: this.endingHourFormat,
            pixabayID: this.$store.state.pixabayImageID,
            tpf: this.videoDuration,
            cadrage_paysage: null,
            cadrage_portrait: null
          }
          let form = new FormData()
          let file = this.file

          form.append('file', file)
          let config = {
            header : {
              'Content-Type' : 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
              var percentUploaded = Math.trunc(Math.round((progressEvent.loaded * 100) / progressEvent.total))
              setTimeout(() => {
                this.uploadProgress = '(' + percentUploaded + '%)'
              }, 1000)
            }
          }
          const responseUpload = await FtpService.uploadLargeMedia(form, config)
          var filePath = responseUpload.data.filePath

          if (responseUpload.status === 200) {
            this.uploadProgress = ''
            this.uploadMessage = 'Votre vidéo est en cours de traitement.'
            if (this.$store.state.user.id !== 295 || this.$store.state.selectedSite.SitNom !== 'Tous') {
              if (this.availableSites.length === 1) {
                if (this.selectedLandscapeScreens.length > 0) {
                  const response = await FtpService.uploadVideo({
                    videoSettings: this.nameExtension,
                    videoFormat: this.videoFormat,
                    site: this.$store.state.selectedSite,
                    screens: this.selectedLandscapeScreens,
                    propertiesData: propertiesDataObject,
                    uniqueID: uniqueID,
                    videoSize: '1366:768',
                    videoPath: filePath,
                    sound: this.sound,
                    random: random
                  })
                  if (response.status === 200) {
                    var thumbnailFile = response.data.thumbnailFile
                    const thumbnailResponse = await FtpService.createVideoThumbnail({
                      thumbnailFile: thumbnailFile,
                      uniqueID: uniqueID,
                      site: this.$store.state.selectedSite,
                      screens: this.selectedLandscapeScreens,
                      videoSize: '480:270', 
                      random: random             
                    })        
                  }
                }
                if (this.selectedPortraitScreens.length > 0 ) {
                  if (this.hasTwoByFourScreens) {
                    const response = await FtpService.uploadVideo({
                      videoSettings: this.nameExtension,
                      videoFormat: this.videoFormat,
                      uniqueID: uniqueID,
                      site: this.$store.state.selectedSite,
                      screens: this.selectedPortraitScreens,
                      propertiesData: propertiesDataObject,
                      videoSize: '608:2160',
                      videoPath: filePath,
                      sound: this.sound,
                      random: random
                    })        
                    if (response.status === 200) {
                      var thumbnailFile = response.data.thumbnailFile
                      const thumbnailResponse = await FtpService.createVideoThumbnail({
                        thumbnailFile: thumbnailFile,
                        uniqueID: uniqueID,
                        site: this.$store.state.selectedSite,
                        screens: this.selectedPortraitScreens,
                        videoSize: '76:270',
                        random: random
                      }) 
                    }
                  } else {
                    const response = await FtpService.uploadVideo({
                      videoSettings: this.nameExtension,
                      videoFormat: this.videoFormat,
                      uniqueID: uniqueID,
                      site: this.$store.state.selectedSite,
                      screens: this.selectedPortraitScreens,
                      propertiesData: propertiesDataObject,
                      videoSize: '768:1366',
                      videoPath: filePath,
                      sound: this.sound,
                      random: random
                    })        
                    if (response.status === 200) {
                      var thumbnailFile = response.data.thumbnailFile
                      const thumbnailResponse = await FtpService.createVideoThumbnail({
                        thumbnailFile: thumbnailFile,
                        uniqueID: uniqueID,
                        site: this.$store.state.selectedSite,
                        screens: this.selectedPortraitScreens,
                        videoSize: '152:270',
                        random: random
                      }) 
                    }
                  }               
                }
                if (this.selectedLedScreens.length > 0 ) {
                  const response = await FtpService.uploadVideo({
                    videoSettings: this.nameExtension,
                    videoFormat: this.videoFormat,
                    uniqueID: uniqueID,
                    site: this.$store.state.selectedSite,
                    screens: this.selectedLedScreens,
                    propertiesData: propertiesDataObject,
                    videoSize: '480:360',
                    videoPath: filePath,
                    sound: false,
                    random: random
                  })
                  if (response.status === 200) {
                    var thumbnailFile = response.data.thumbnailFile
                    const thumbnailResponse = await FtpService.createVideoThumbnail({
                      thumbnailFile: thumbnailFile,
                      uniqueID: uniqueID,
                      site: this.$store.state.selectedSite,
                      screens: this.selectedLedScreens,
                      videoSize: '480:360',
                      random: random
                    }) 
                  }
                }
                const dbResponse = await DBService.registerMediaProperties({
                  imageSettings: this.nameExtension,
                  site: this.$store.state.selectedSite,
                  screens: this.chosenScreens,
                  propertiesData: propertiesDataObject,
                  uniqueID: uniqueID,
                  user: this.$store.state.user.id,
                  isVideo: true,
                  random: random
                })
                if (dbResponse) {
                  if (dbResponse.status === 200) {
                    this.$store.dispatch('setUploadSuccessful', true)
                    this.$emit('close')
                    this.$router.replace({
                      name: 'MyContent'
                    })
                  }
                }
              } else {
                this.screensbySite.forEach(async function (element, index, array){
                  if (element.screens.length === 0 && !(index === (array.length - 1))) {                  
                    return
                  } else if (element.screens.length === 0 && (index === (array.length - 1))) {
                    setTimeout(() => {
                      this.$store.dispatch('setUploadSuccessful', true)
                      this.$emit('close')
                      this.$router.replace({
                        name: 'MyContent'
                      })
                    }, 1000)    
                    return
                  }                
                  var siteToUploadTo = element.site
                  var selectedLandscapeScreens = element.screens.filter(function (screen){
                    return screen.fk_screen_type === 1
                  })
                  var selectedPortraitScreens = element.screens.filter(function (screen){
                    return screen.fk_screen_type === 2 || screen.fk_screen_type === 4
                  })
                  var selectedLedScreens = element.screens.filter(function (screen){
                    return screen.fk_screen_type === 3
                  })
                  if (selectedLandscapeScreens.length > 0) {
                    const response = await FtpService.uploadVideo({
                      videoSettings: this.nameExtension,
                      videoFormat: this.videoFormat,
                      site: siteToUploadTo,
                      screens: selectedLandscapeScreens,
                      propertiesData: propertiesDataObject,
                      uniqueID: uniqueID,
                      videoSize: '1366:768',
                      videoPath: filePath,
                      sound: this.sound,
                      random: random
                    })
                    if (response.status === 200) {
                      var thumbnailFile = response.data.thumbnailFile
                      const thumbnailResponse = await FtpService.createVideoThumbnail({
                        thumbnailFile: thumbnailFile,
                        uniqueID: uniqueID,
                        site: siteToUploadTo,
                        screens: selectedLandscapeScreens,
                        videoSize: '480:270', 
                        random: random             
                      })        
                    }
                  }
                  if (selectedPortraitScreens.length > 0 ) {
                    if (this.hasTwoByFourScreens) {
                      const response = await FtpService.uploadVideo({
                        videoSettings: this.nameExtension,
                        videoFormat: this.videoFormat,
                        uniqueID: uniqueID,
                        site: siteToUploadTo,
                        screens: selectedPortraitScreens,
                        propertiesData: propertiesDataObject,
                        videoSize: '608:2160',
                        videoPath: filePath,
                        sound: this.sound,
                        random: random
                      })        
                      if (response.status === 200) {
                        var thumbnailFile = response.data.thumbnailFile
                        const thumbnailResponse = await FtpService.createVideoThumbnail({
                          thumbnailFile: thumbnailFile,
                          uniqueID: uniqueID,
                          site: siteToUploadTo,
                          screens: selectedPortraitScreens,
                          videoSize: '76:270',
                          random: random
                        }) 
                      }
                    } else {
                      const response = await FtpService.uploadVideo({
                        videoSettings: this.nameExtension,
                        videoFormat: this.videoFormat,
                        uniqueID: uniqueID,
                        site: siteToUploadTo,
                        screens: selectedPortraitScreens,
                        propertiesData: propertiesDataObject,
                        videoSize: '768:1366',
                        videoPath: filePath,
                        sound: this.sound,
                        random: random
                      })        
                      if (response.status === 200) {
                        var thumbnailFile = response.data.thumbnailFile
                        const thumbnailResponse = await FtpService.createVideoThumbnail({
                          thumbnailFile: thumbnailFile,
                          uniqueID: uniqueID,
                          site:siteToUploadTo,
                          screens: selectedPortraitScreens,
                          videoSize: '152:270',
                          random: random
                        }) 
                      }
                    }               
                  }
                  if (this.selectedLedScreens.length > 0 ) {
                    const response = await FtpService.uploadVideo({
                      videoSettings: this.nameExtension,
                      videoFormat: this.videoFormat,
                      uniqueID: uniqueID,
                      site: siteToUploadTo,
                      screens: selectedLedScreens,
                      propertiesData: propertiesDataObject,
                      videoSize: '480:360',
                      videoPath: filePath,
                      sound: false,
                      random: random
                    })
                    if (response.status === 200) {
                      var thumbnailFile = response.data.thumbnailFile
                      const thumbnailResponse = await FtpService.createVideoThumbnail({
                        thumbnailFile: thumbnailFile,
                        uniqueID: uniqueID,
                        site: siteToUploadTo,
                        screens: selectedLedScreens,
                        videoSize: '480:360',
                        random: random
                      }) 
                    }
                  }
                  const dbResponse = await DBService.registerMediaProperties({
                    imageSettings: this.nameExtension,
                    site: siteToUploadTo,
                    screens: element.screens,
                    propertiesData: propertiesDataObject,
                    uniqueID: uniqueID,
                    user: this.$store.state.user.id,
                    isVideo: true,
                    random: random
                  })
                  if (dbResponse) {
                    if (dbResponse.status === 200 && index === (array.length - 1)) {
                      this.$store.dispatch('setUploadSuccessful', true)
                      this.$emit('close')
                      this.$router.replace({
                        name: 'MyContent'
                      })
                    }
                  }
                }, this)
              }
            } else if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom === 'Tous'){
              if (this.selectedLandscapeGroups.length > 0) {
                const response = await FtpService.uploadVideoToCultura({
                  videoSettings: this.nameExtension,
                  groups: this.selectedLandscapeGroups,
                  propertiesData: propertiesDataObject,
                  uniqueID: uniqueID,
                  videoSize: '1366:768',
                  videoPath: filePath,
                  sound: this.sound
                })
                if (response.status === 200) {
                  var thumbnailFile = response.data.thumbnailFile
                  const thumbnailResponse = await FtpService.createVideoThumbnailToCultura({
                    thumbnailFile: thumbnailFile,
                    uniqueID: uniqueID,
                    groups: this.selectedLandscapeGroups,
                    videoSize: '480:270', 
                  })        
                }
              }
              if (this.selectedPortraitGroups.length > 0) {
                const response = await FtpService.uploadVideoToCultura({
                  videoSettings: this.nameExtension,
                  groups: this.selectedPortraitGroups,
                  propertiesData: propertiesDataObject,
                  uniqueID: uniqueID,
                  videoSize: '768:1366',
                  videoPath: filePath,
                  sound: this.sound
                })
                if (response.status === 200) {
                  var thumbnailFile = response.data.thumbnailFile
                  const thumbnailResponse = await FtpService.createVideoThumbnailToCultura({
                    thumbnailFile: thumbnailFile,
                    uniqueID: uniqueID,
                    groups: this.selectedPortraitGroups,
                    videoSize: '152:270', 
                  })        
                }
              }
              if (this.selectedLedGroups.length > 0) {
                const response = await FtpService.uploadVideoToCultura({
                  videoSettings: this.nameExtension,
                  groups: this.selectedLedGroups,
                  propertiesData: propertiesDataObject,
                  uniqueID: uniqueID,
                  videoSize: '480:360',
                  videoPath: filePath,
                  sound: this.sound
                })
                if (response.status === 200) {
                  var thumbnailFile = response.data.thumbnailFile
                  const thumbnailResponse = await FtpService.createVideoThumbnailToCultura({
                    thumbnailFile: thumbnailFile,
                    uniqueID: uniqueID,
                    groups: this.selectedLedGroups,
                    videoSize: '480:360', 
                  })        
                }
              }
              const dbResponse = await DBService.registerMediaPropertiesCultura({
                imageSettings: this.nameExtension,
                groups: this.selectedCultura,
                propertiesData: propertiesDataObject,
                uniqueID: uniqueID,
                user: this.$store.state.user.id,
                isVideo: true,
                random: random
              })
              if (dbResponse) {
                if (dbResponse.status === 200) {
                  this.$store.dispatch('setUploadSuccessful', true)
                  this.$emit('close')
                  this.$router.replace({
                    name: 'MyContent'
                  })
                }
              }
            }
          }       
        }
        reader.readAsDataURL(this.file)
      } else {
        var propertiesDataObject = {
            titre: this.videoName,
            bandeauEnseigne: false,
            etat: 1,
            selectedDays: this.selectedDaysIDCSV,
            dateDebut: this.startingDate,
            dateFin: this.endingDate,
            heureDebut: this.startingHourFormat,
            heureFin: this.endingHourFormat,
            pixabayID: this.$store.state.pixabayImageID,
            tpf: this.$store.state.pixabayDuration,
            cadrage_paysage: null,
            cadrage_portrait: null
          }
        if (this.selectedLandscapeScreens.length > 0) {
          const response = await FtpService.uploadPixabayVideo({
            screens: this.selectedLandscapeScreens,
            site: this.$store.state.selectedSite,
            videoSettings: this.nameExtension,
            uniqueID: uniqueID,
            videoSize: '1366:768',
            videoURL: this.videoSrc,
            random: random
          })
          if (response.status === 200) {
            var thumbnailFile = response.data.thumbnailFile
            const thumbnailResponse = await FtpService.createVideoThumbnail({
              thumbnailFile: thumbnailFile,
              uniqueID: uniqueID,
              site: this.$store.state.selectedSite,
              screens: this.selectedLandscapeScreens,
              videoSize: '480:270',
              random: random
            })        
          }
        }
        if (this.selectedPortraitScreens.length > 0) {
           const responsePortrait = await FtpService.uploadPixabayVideo({
            screens: this.selectedPortraitScreens,
            site: this.$store.state.selectedSite,
            videoSettings: this.nameExtension,
            uniqueID: uniqueID,
            videoSize: '768:1366',
            videoURL: this.videoSrc,
            random: random
          })
          if (responsePortrait.status === 200) {
            var thumbnailFile = response.data.thumbnailFile
            const thumbnailResponsePortrait = await FtpService.createVideoThumbnail({
              thumbnailFile: thumbnailFile,
              uniqueID: uniqueID,
              site: this.$store.state.selectedSite,
              screens: this.selectedPortraitScreens,
              videoSize: '152:270',
              random: random
            })        
          }
        }
        if (this.selectedLedScreens.length > 0) {
          const responseLed = await FtpService.uploadPixabayVideo({
            screens: this.selectedLedScreens,
            site: this.$store.state.selectedSite,
            videoSettings: this.nameExtension,
            uniqueID: uniqueID,
            videoSize: '480:360',
            videoURL: this.videoSrc,
            random: random
          })
          if (responseLed.status === 200) {
            var thumbnailFile = response.data.thumbnailFile
            const thumbnailResponseLed = await FtpService.createVideoThumbnail({
              thumbnailFile: thumbnailFile,
              uniqueID: uniqueID,
              site: this.$store.state.selectedSite,
              screens: this.selectedLedScreens,
              videoSize: '480:360',
              random: random
            })        
          }
        }
        const dbResponse = await DBService.registerMediaProperties({
          imageSettings: this.nameExtension,
          site: this.$store.state.selectedSite,
          screens: this.chosenScreens,
          propertiesData: propertiesDataObject,
          uniqueID: uniqueID,
          user: this.$store.state.user.id,
          isVideo: true
        })
        if (dbResponse) {
          if (dbResponse.status === 200) {
            this.$emit('close')
            this.$router.replace({
              name: 'MyContent'
            })
          }
        }
      }
    },
    addBrandScreens(brand) {
      if (this.selectedKazed.includes(brand)) {
        if (brand.prefix === ''){
          this.availableScreens.forEach(screen =>{
            if (!screen.server_name.startsWith('Casto_') &&
            !screen.server_name.startsWith('MrBricolage_') &&
            !screen.server_name.startsWith('EDB_') &&
            !screen.server_name.startsWith('BBJ_')) {
              if (!this.chosenScreens.includes(screen))
                this.chosenScreens.push(screen)
            }
          })
        } else {
          this.availableScreens.forEach(screen =>{
            if (screen.server_name.startsWith(brand.prefix)) {
              if (!this.chosenScreens.includes(screen))
                this.chosenScreens.push(screen)
            }
          })
        }
      } else {
        this.chosenScreens = []
        this.selectedKazed.forEach(enseigne => {
          if (enseigne.prefix === '') {
            this.availableScreens.forEach(screen =>{
              if (!screen.server_name.startsWith('Casto_') &&
              !screen.server_name.startsWith('MrBricolage_') &&
              !screen.server_name.startsWith('EDB_') &&
              !screen.server_name.startsWith('BBJ_')) {
                if (!this.chosenScreens.includes(screen))
                  this.chosenScreens.push(screen)
              }
            })
          } else {
            this.availableScreens.forEach(screen =>{
              if (screen.server_name.startsWith(enseigne.prefix)) {
                if (!this.chosenScreens.includes(screen))
                  this.chosenScreens.push(screen)
              }
            })
          }
        })
      }
    },
    addGroup(group) {
      this.selectedCultura.push(group)
      if (group.type === 1) {
        this.selectedLandscapeGroups.push(group)
      } else if (group.type === 2) {
        this.selectedPortraitGroups.push(group)
      } else {
        this.selectedLedGroups.push(group)
      }
    },
    removeGroup(group) {
      this.selectedCultura = this.selectedCultura.filter(function (element) {
        if (element.name !== group.name) {
          return element
        }
      })
      if (group.type === 1) {
        this.selectedLandscapeGroups = this.selectedLandscapeGroups.filter(function (element) {
          if (element.name !== group.name) {
            return element
          }
        })
      } else if (group.type === 2) {
         this.selectedPortraitGroups = this.selectedPortraitGroups.filter(function (element) {
          if (element.name !== group.name) {
            return element
          }
        })
      } else {
         this.selectedLedGroups = this.selectedLedGroups.filter(function (element) {
          if (element.name !== group.name) {
            return element
          }
        })
      }
    },
    screenIcon (screenType) {
      if (screenType === 1) {
        return this.imgSrcLandscape
      } else if (screenType === 2 || screenType === 4) {
        return this.imgSrcPortrait
      } else if (screenType === 3) {
        return this.imgSrcLED
      }
    },
    removeHours () {
      this.setBroadCastHours = false
      this.endingHour.HH = ''
      this.endingHour.mm = '00'
      this.startingHour.HH = ''
      this.startingHour.mm = '00'
      this.isEndingHourValid = false
      this.isStartingHourValid = false
    },
    addScreen (screen) {
      this.chosenScreens.push(screen)
      this.availableScreens = this.currentSite.screens
      var nbOfSelectedScreens = 0
      var currSite = this.currentSite
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens.push(screen)
        }
      })
      this.chosenScreens.forEach(function (element) {
        if (element.fk_site_id === currSite.SitId) 
          nbOfSelectedScreens++
      })
      this.allScreensFromCurrentSite = nbOfSelectedScreens === this.currentSite.screens.length
      this.allScreens = nbOfSelectedScreens === this.currentSite.screens.length
    },
    removeScreen (screen) {
      this.chosenScreens = this.chosenScreens.filter(function (element) {
        if (element.id !== screen.id) {
          return element
        }
      })
      var currSite = this.currentSite
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens = element.screens.filter(screens => {
            if (screens.id !== screen.id) {
              return screens
            }
          })
        }
      })
      this.allScreens = false
      this.allScreensFromCurrentSite = false
    }
  },
  computed: {
    schedule: function () {
      if (this.endingDate) {
        return 'Du ' + this.startingDate + ' au ' + this.endingDate + '.'
      } else {
        return 'À partir du ' + this.startingDate + '.'
      }
    },
    hours: function () {
      if (this.startingHour && !this.endingHour) {
        return 'À partir de ' + this.startingHour.HH + ':' + this.startingHour.mm + '.'
      } else if (!this.startingHour && this.endingHour) {
        return 'Jusqu\' à ' + this.endingHour.HH + ':' + this.startingHour.mm + '.'
      } else if (this.startingHour && this.startingHour) {
        return 'Entre ' + this.startingHour.HH + ':' + this.startingHour.mm + ' et ' + this.endingHour.HH + ':' + this.startingHour.mm + '.'
      }
    },
    orderedDays: function () {
      var days = []
      var returnValue = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          return this.chosenDays[i].name
        } else {
          days = this.chosenDays.slice().sort(compareById)
          days.forEach(function(element) {
            returnValue += element.name + ', '
          })
          return returnValue.substring(0, returnValue.length-2)
        }
      }
    }
  },
   watch: {
    startingHour: function () {
      if (!this.setBroadCastHours) {
        this.isStartingHourValid = true
      } else if (!(this.startingHour.HH !== '' && this.startingHour.mm !== '')) {
        this.isStartingHourValid = false
      } else {
        this.isStartingHourValid = true
      }
    },
    endingHour: function () {
      if (!this.setBroadCastHours) {
        this.isEndingHourValid = true
      } else if (!(this.endingHour.HH !== '' && this.endingHour.mm !== '')) {
        this.isEndingHourValid = false
      } else {
        this.isEndingHourValid = true
      }
    },
    chosenDays: function () {
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0 && this.chosenDays.length > 1) {
          this.chosenDays.splice(i, 1)
          break
        }
      }
    },
    currentSite: function () {
      this.availableScreens = this.currentSite.screens.filter(screen => screen.name !== "Ligne de caisse")
      var nbOfSelectedScreens = 0
      var currSite = this.currentSite
      this.chosenScreens.forEach(function (element) {
        if (element.fk_site_id === currSite.SitId) 
          nbOfSelectedScreens++
      })
      this.allScreensFromCurrentSite = nbOfSelectedScreens === this.currentSite.screens.length
    }
  }
}

function compareById (a, b) {
  if (a.id < b.id) {
    return -1
  }
  if (a.id > b.id) {
    return 1
  }
  return 0
}
</script>

<style scoped>

#sticker div[role=menu]{
  z-index: 5!important;
}

.vert-align-top{
  vertical-align: top;
}

.divAddBlock{
  display: block;
  overflow-y: visible;
}

.divObject{
  vertical-align: top;
  /* display: inline-block; */
  display: flex;
  margin-right: 14px;
/*   background-color:rgba(85, 86, 94, 0.10);
 */  background-color: rgba(9, 5, 33,0.1);
  height:36px;
  width:auto;
  border-radius:50em;
}

.divObjectStickers{
  vertical-align: top;
  /* display: inline-block; */
  display: flex;
  margin-right: 14px;
/*   background-color:rgba(85, 86, 94, 0.10);*/
  height:36px;
  width:auto;
  border-radius:50em;
}

.icon-list-container{
  border-radius: 0px 16px 16px 16px;
  overflow: hidden;
}

.icon-list {
  background-color: var(--v-contrast-base)!important;
  max-width: 600px;
  height: 270px;
  overflow:auto;
  padding: 4px;
}

.icon-list-item{
  position:relative;
  height: 100px!important;
  width: 100px!important;
  margin:4px;
}

.form-checkbox {
  margin: auto;
  display: flex;
/*   display: block;
 */  margin-right: 10px;
  padding-top:0px!important;
  margin-left:-2px!important;
}

.divBlock{
  overflow: visible;
  width: 100%;
  display:flex;
  flex-direction:column;
}

.div-align-top{
  vertical-align: top;
}

.broadcast-days-div{
  max-width: 500px;
}

.btnAddContent{
  height: 25px;
  width: 25px;
}

.select-screen-container{
  position:relative;
  width:180px!important;
  height:180px!important;
/*   background-color: lightblue;
 */}

.theme--light .select-screen-image-bloc{
  width:100px!important;
  height:100px!important;
  border-radius:50em;
  margin-bottom:16px;
  background-color:var(--v-primary-base);
}

.theme--dark .select-screen-image-bloc{
  width:100px!important;
  height:100px!important;
  border-radius:50em;
  margin-bottom:16px;
  background-color: rgb(37, 39, 53);
}

.select-screen-image{
  overflow:visible;
  cursor:pointer;
  height:100%;
  width:100%;
}

.select-screen-button{
  height:30px;
  width:30px;
  position:absolute;
  z-index:1;
  bottom:0;
  right:0;
/*   cursor: initial;
 */}
</style>
